'use client';
import { JumboNavbar } from 'themes/jumbo/@jumbo/components';
import { useJumboLayout } from 'themes/jumbo/@jumbo/components/JumboLayout/hooks';
import { JumboScrollbar } from 'themes/jumbo/@jumbo/components/JumboScrollbar';
import { useJumboSidebarTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import { Div } from 'themes/jumbo/@jumbo/shared';
import { MenuItems } from 'themes/jumbo/@jumbo/types';
import { SIDEBAR_VIEWS } from 'themes/jumbo/@jumbo/utilities/constants';
import React, { Suspense } from 'react';
import { SidebarHeader, SidebarSkeleton } from './components';
import { Copyright } from './components/Copyright';
import { tss } from "tss-react";

type SidebarProps = {
  menus: MenuItems;
};

const useStyles = tss.create({
	appNavBar: {
		marginRight: '0px !important',
    overflow: 'hidden !important'
	}
})

function Sidebar({ menus }: SidebarProps) {
  const { sidebarTheme } = useJumboSidebarTheme();
  const { sidebarOptions } = useJumboLayout();
  const isMini = sidebarOptions.view === SIDEBAR_VIEWS.MINI;
  const { classes } = useStyles();

  return (
    <React.Fragment>
      <SidebarHeader />
      <JumboScrollbar className={classes.appNavBar}>
        <Suspense
          fallback={
            <Div
              sx={{
                display: 'flex',
                minWidth: 0,
                alignItems: 'center',
                alignContent: 'center',
                px: 3,
              }}
            >
              <SidebarSkeleton />
            </Div>
          }
        >
          {/* <SidebarSkeleton /> */}
          <JumboNavbar
            items={menus}
            theme={sidebarTheme}
            mini={isMini}
            open={sidebarOptions.open}
          />
        </Suspense>
      </JumboScrollbar>
      { <Copyright /> }
    </React.Fragment>
  );
}

export { Sidebar };
